"use client"

import { useQuery } from "@tanstack/react-query"

import { useAuth } from "@/hooks/auth/use-auth"
import type { AutoReplyDetails } from "@/lib/agents/email/auto-reply-details"

export const autoReplyQueryKey = (autoReplyId: string | null) => ["email", "auto-reply", autoReplyId] as const

/** One auto-reply with its original email and thread history, as the viewer dialog shows it. */
export function useAutoReplyDetailsQuery(autoReplyId: string | null) {
  const { fetchWithAuth } = useAuth()

  return useQuery({
    queryKey: autoReplyQueryKey(autoReplyId),
    enabled: !!autoReplyId,
    retry: false,
    queryFn: async (): Promise<AutoReplyDetails> => {
      const response = await fetchWithAuth(`/api/agents/email/auto-reply/${autoReplyId}`)
      const payload = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(payload.error || "Failed to load the agent's reply")
      return payload.autoReply
    },
  })
}
